import { getSize } from "views/resources/theme";

export const hiddenWrap = (props) => {
	const size = getSize("s")(props);
	if (props.isOpen) {
		return `margin: ${size};`;
	} else {
		return `margin: 0 ${size};`;
	}
};
